module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Utforsk videoer fra økosystemet","text":"Vi utvikler akselerert læring og vaneendring av 100 ferdigheter. Kos deg med brain dates fra tusenvis av videoer så lenge."},"en":{"title":"Explore Videos from the Ecosystem","text":"We\u0027re developing accelerated learning and habit change of 100 life skills. Enjoy brain dates from thousands of videos in the meantime."}}')
  delete Component.options._Ctor
}
